export default {"src":"/_next/static/media/password_eye.ccaecfb1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};